/**
 * Sidebar / mobile header logo morph — pause on hover, touch, or hidden tab
 */
(function () {
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  const roots = new Set();

  function shouldRun() {
    return !REDUCED.matches;
  }

  function pauseAll() {
    roots.forEach((root) => root.classList.add('is-paused'));
  }

  function resumeAll() {
    if (!shouldRun() || document.visibilityState !== 'visible') return;
    roots.forEach((root) => root.classList.remove('is-paused'));
  }

  function bindGlobalListeners() {
    if (bindGlobalListeners.done) return;
    bindGlobalListeners.done = true;

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') pauseAll();
      else resumeAll();
    });

    REDUCED.addEventListener('change', () => {
      if (!shouldRun()) pauseAll();
      else resumeAll();
    });
  }

  function initLogoMorph() {
    document.querySelectorAll('[data-logo-morph]').forEach((root) => {
      if (roots.has(root)) return;
      roots.add(root);

      if (!shouldRun()) {
        root.classList.add('is-paused');
        return;
      }

      root.classList.remove('is-paused');

      const pause = () => root.classList.add('is-paused');
      const resume = () => {
        if (shouldRun() && document.visibilityState === 'visible') {
          root.classList.remove('is-paused');
        }
      };

      root.addEventListener('mouseenter', pause);
      root.addEventListener('mouseleave', resume);
      root.addEventListener('focusin', pause);
      root.addEventListener('focusout', resume);
      root.addEventListener('touchstart', pause, { passive: true });
      root.addEventListener('touchend', resume, { passive: true });
      root.addEventListener('touchcancel', resume, { passive: true });
    });

    bindGlobalListeners();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLogoMorph);
  } else {
    initLogoMorph();
  }
})();
